module.exports = {
  language:{
    name:'中文'
  },
  search:'search',
  resetSearch:'reset search',
  serialNo:'NO.',
  equipmentName:'equipment name',
  equipmentNo:'equipment NO',
  operation:'operation',
  cancel:'cancel',
  confirm:'confirm',
  startDate:'start date',
  endDate:'end date',
  to:'to',
  amount:'amount',
  check:'check',
  edit:'edit',
  delete:'delete',
  save:'save',
  dtuNo:'dtuNo',
  refresh:'refresh',
  export:'export',
  import:"import",
  user:'user',
  equipmentType:'equipment type',
  multiple:'multiple',
  key:'key',
  keyNumber:'key number',
  beverageName:'beverage name',
  price:'price',
  englishName:'english name',
  selectRecipe:'select recipe',
  yuan:'yuan',
  operationSucceeded:'operation succeeded',
  cupTypeSerialNo:'cup type serialNo',
  cupTypePercentage:'cup type percentage',
  setAmount:'set amount',
  paidInAmount:'paid in amount',
  none:'none',
  nodata:'nodata',
  yes:'yes',
  no:'no',
  noPicture:'no picture',
  selectedImage:'selected image',
  notSelectedImage:'unselected image',
  pleaseSelectTheEquipmentModel:'please select the equipment model',
  pleaseEnterTheContent:'please enter the content',
  beverageImage:'beverage image',
  notSelected:'not selected',
  browse:'browse',
  variableName:'variable name',
  upload:'upload',
  image:'image',
  confirmModification:'confirm modification',
  noChoiceNow:'no choice now',
  equipment:'equipment',
  success:'success',
  back:'back',
  ok:'ok',
  okSpace:'ok',
  queryFailedStatusCode:'query failed!status code:',
  selectAll:'select all',
  issued:'issued',
  deleteSuccessfully:'delete successfully',
  tips:'tips',
  updateData:'update date',
  cancelInput:'cancel input',
  saveSuccessfully:'save successfully',
  configureSuccessfully:'configure successfully',
  saveFailed:'save failed',
  updateDate:'update date',
  equipmentmanagement:{
    ExcelBatchModify:'Excel Batch Modify',
    salesChannel:'sales channel',
    query:'query',
    add:'add',
    dtuNumber:'dtuNo',
    machineModel: 'model',
    runningStatus: 'running status',
    totalNumberOfCups: 'total number',
    totalAmount:'total amount',
    signal:'signal',
    signalIntensity:'signal',
    netWorkStatus:'net work status',
    activationTime:'activation time',
    flowRecord:'flow record',
    online:'online',
    offline:'offline',
    parameterConfiguration: 'parameter configuration',
    copy:'copy',
    recipeAssignment:'recipe assignment',
    addEquipment:'add equipment',
    maximumNumberOfKeys:'max keys num',
    editEquipmentInfo:'edit equipment info',
    simCardNo:'sim card NO',
    noSalesChannel:'no sales channel',
    selectRecipeLibraryToAssign:'select recipe library to assign',
    selectByExistingGroup:'select by existing group',
    checkAssigned:'check assigned',
    beverageName:'beverage name',
    noPicture:'no picture',
    ingredientName:'ingredient name',
    category:'category',
    coffee:'coffee',
    milkTea:'milkTea',
    soybeanMilk:'soybean milk',
    juice:'juice',
    cupType:'cup type',
    selectedImage:'selected image',
    selectTheEquipmentToBeCopied:'select the equipment to be copied',
    checkSelectedEquipments:'check selected equipments',
    copyEquipmentParameters:'copy equipment parameters',
    copyKeyParameters:'copy key parameters',
    copyPictureLibrary:'copy picture library',
    copyPartOfParameters:'copy part of parameters',
    confirmAssignment:'confirm assignment',
    currentMachineModel:'current machine model',
    functionSetting:'function setting',
    commonKeySetting:'common key setting',
    equipmentImageLibrarySettings:'equipment image library settings',
    equipmentVideoSetting:'equipment video setting',
    dataStatistics:'data statistics',
    ingredientsSelection:'ingredients selection',
    ingredientsSelectionOfBeanToCupCoffeeMachine:'ingredients selection of bean to cup coffee machine',
    priceSetting:'price setting',
    beverageCalibration:'beverage calibration',
    selectTemplate:'select template',
    templateName:'template name',
    qualityInspectionSituation:'quality inspection',
    unqualifiedReason:'unqualified reason',
    qualified:'qualified',
    unqualified:'unqualified',
    qualityInspection:'quality inspection',
    clearTestData:'clear test data',
    username:'username',
    userLevel:'user level',
    assignedEquipments:'assigned equipments',
    assignment:'assignment',
    emptyAssignment:'empty assignment',
    assignEquipmentName:'assign equipment name',
    faultCode:'fault code',
    faultInformation:'fault information',
    pleaseSelectTheSalesChannel:'please select the sales channel',
    manualPositioning:'manual position',
    checkRecipe:'check recipe',
    equipmentParameterConfiguration:'equipment parameter configuration',
    checkTheSelectedEquipment:'check the selected equipment',
    whetherToConfirmToDeleteTheEquipment:'whether to confirm to delete the equipment',
    dispensingTime:'dispensing time',
    confirmEquipment:'confirm that the equipment passes the quality inspection',
    confirmToPass:'confirm to pass',
    noPass:'no pass',
    reasonForNoPass:'reason for no pass',
    pleaseEnterTheReasonForNoPass:'please enter the reason for no pass',
    submit:'submit',
    editEquipmentAssignment:'edit equipment assignment',
    androidVersion:'android version',
    mainBoardVersion:'main board version',
    createDate:'create date',
    equipmentParameter:'equipment parameter',
    latestSubmittedData:'latest submitted data',
    simCardNO:'SIM card NO',
    equipmentAddress:'equipment address',
    pass:'pass',
    salesDetail:'sales detail',
    faultList:'fault list',
    logUpload:'log upload',
    checkPaymentQRCode:'check payment QR code',
    faultTime:'fault time',
    endTime:'end time',
    fileList:'file list',
    paymentQRCode:'payment QR code',
    timeSelection:'time selection',
    selectTime:'select time',
    currentValue:'current value',
    loading:'loading',
    open:'open',
    close:'close',
    video:'video',
    name:'name',
    time:'time',
    read:'read',
    currentData:'current data',
    historicalData:'historical data',
    totalSalesNumberOfCups:'total sales number of cups',
    totalSalesAmount:'total sales amount',
    pleaseSelect:'please select',
    equipmentLog:'equipment log',
    manuallySelectTheEquipmentLocation:'manually select the equipment location',
    dataReading:'data reading,please wait',
    readingSuccessfully:'reading successfully',
    failedToReadParameters:'failed to read parameters!please try again',
    theParameterOrNodeIsAbnormal:'the parameter or node is abnormal',
    theInputValueIsIncorrect:'the input value is incorrect',
    dataSavingPleaseWait:'data saving,please wait',
    cannotBeEmpty:'cannot be empty',
    pleaseEnterANumber:'please enter a number',
    theInputParameterNeedsToBeLessThanTheMaximumValue:'the input parameter needs to be less than the maximum value',
    theInputParameterNeedsToBeGreaterThanTheMinimumValue:'the input parameter needs to be greater than the minimum value',
    editKeySettings:'editKeySetting',
    thisOperationWillPermanentlyDeleteThisKey:'this operation will permanently delete this key,continue or not?',
    deletionCancelled:'deletion cancelled',
    incorrectParameterName:'incorrect parameter name',
    modifyTheKeyConfigurationSuccessfully:'modify the key configuration successfully!',
    pleaseCompleteTheConfigurationInformation:'please complete the configuration information',
    keyNumberAlreadyExists:'key number already exists!',
    newlyAddKeyParameterConfigurationSuccessfully:'newly add key parameter configuration successfully!',
    theSizeOfTheUploadedImageCannotMoreThan2MB:'the size of the uploaded image cannot more than 2MB!',
    deleteImageSuccessfully:'delete image successfully!',
    tickAtLeastOneVideoToBeDeleted:'tick at least one video to be deleted',
    powderCanister:'powder canister',
    noIngredientForThisEquipment:'no ingredient for this equipment',
    powderVolumeIncreased:'powder volume increased',
    normal:'normal',
    muchStronger:'much stronger',
    extraStrong:'extra strong',
    fineAdjustmentOfCupVolume:'fine adjustment of cup volume',
    channelInformationSavedSuccessfully:'channel information saved successfully!',
    modifyPriceSuccessfully:'modify price successfully!',
    refreshSuccessfully:'refresh successfully',
    commandIssuedSuccessfully:'command issued successfully',
    equipmentInformationAcquisitionAbnormal:'equipment information acquisition abnormal!',
    thisImageHasBeenSelected:'this image has been selected',
    imageLibrarySavedSuccessfully:'image library saved successfully!',
    imageLibrarySavedUnSuccessfully:'image library saved unsuccessfully!',
    equipmentInformationAcquisitionFailed:'equipment information acquisition failed!',
    pleaseSelectTheImageToBeDeleted:'please select the image to be deleted',
    batchAssignmentTaskCreatedSuccessfully:'batch assignment task created successfully.please go to "my task" to check',
    automaticPositioningAcquisitionFailed:'automatic positioning acquisition failed',
    theEquipmentHasNoLocationInformationTemporarily:'the equipment has no location information temporarily',
    automaticPositioning:'automatic position',
    noSalesChannelTemporarily:'no sales channel temporarily',
    successfullyAddedEquipment:'successfully added equipment!',
    pleaseCompleteTheEquipmentInformation:'please complete the equipment information',
    pleaseSelectAtLeastOneRecipeLibrary:'please select at least one recipe library',
    confirmToClearTheTestData:'confirm to clear the test data?',
    clearingSuccess:'clearing success!',
    clearingFailed:'clearing failed!',
    failedToObtainUserInformation:'failed to obtain user information!',
    successfullyModifiedTheQualityInspectionInformation:'successfully modified the quality inspection information!',
    pleaseCompleteTheQualityInspectionInformation:'please complete the quality inspection information!',
    thisOperationWillEmptyAllEquipmentsOfThisUser:'this operation will empty all equipments of this user,continue or not?',
    theExportTaskHasBeenCreated:'the export task has been created.please go to my task to check',
    selectedUser:'selected user',
    passwordReset:'password reset',
    selectLevel1User:'select level 1 user',
    pleaseReselectTheUser:'please reselect the user',
    pleaseCompleteUserInformation:'please complete user information',
    modifyPasswordSuccessfully:'modify password successfully!',
    wrongOriginalPassword:'wrong original password!',
    newPasswordInconsistent:'new password inconsistent!',
    pleaseSelectAnAccountFirst:'please select an account first!',
    pleaseSelectTheEquipmentToBeCopied:'please select the equipment to be copied!',
    addEquipmentTypeSuccessfully: 'add equipment type successfully!',
    editEquipmentSuccessfully:'edit equipment successfully',
    equipmentDetail:'equipment detail',
    viewDeviceLog:'view device log',
    inShipment:'in shipment',
    transactionCompletion:'transaction completion',
    statisticsOfKeyCupBeating:'statistics of key cup beating',
    totalCups:'total cups',
    numberOfCups:'number of cups',
    failedToGetLog:'failed to get log',
    failedToObtainDtuNumberPleaseRefreshAndTryAgain:'failed to obtain DTU number,please refresh and try again',
    failedToObtainDeviceParametersPleaseRefreshAndTryAgain:'failed to obtain DTU number,please refresh and try again',
    successfullyDeletedLogFile:'successfully deleted log file',
    selectDeviceAndKeyParameters:'select device and key parameters',
    keyParameters:'key parameters',
    copySucceeded:'copy succeeded',
    copyFailed:'copy failed',
    failedToObtainKeyParameter:'failed to obtain key parameter',
    readFailure: 'read failure',
    successfullyModifiedTheKey:'successfully modified the key',
    pleaseEnterEnglishName:'please enter english name',
    excelBatchEdit:'edit by Excel',
  },
  logginaccount:{
    HFstate:'HF State',
    wxapplet:'wxapplet configuration',
    accountName:'account name',
    loginAccount:'login account',
    nickName:'nick name',
    permissionManagement:'permission management',
    pleaseSelectAUser:'please select a user',
    pleaseSelectAGroup:'please select a group',
    other:'other',
    mobilePhoneNumber:'mobile phone number',
    mailbox:'mailbox',
    status:'status',
    notConfigured:'not configured',
    configured:'configured',
    configuration:'configuration',
    clear:'clear',
    basicInformation:'basic information',
    userOfTheAccount:'user of account',
    alipayAccountConfiguration:'Alipay account configuration',
    weChatPaymentAccountConfiguration:'WeChat payment account configuration',
    weChatAppSecret:'appSecret',
    whetherToConfirmToDeleteThisUser:'whether to confirm to delete this user',
    createLoginAccount:'create login account',
    editLoginAccount:'edit login account',
    loginName:'login name',
    pleaseEnterNickName:'please enter nick name',
    pleaseEnterLoginName:'please enter login name',
    resetPassword:'reset password',
    originalPassword:'original password',
    newPassword:'new password',
    confirmPassword:'confirm password',
    pleaseEnterPassword:'please enter password',
    permissionConfiguration:'permission configuration',
    userInformation:'user information',
    whetherToConfirmToClearPaymentCollectionConfigurationInformation:'whether to confirm to clear payment collection configuration information',
    configurePaymentCollectionInformation:'configure payment collection information',
    merchantID:'merchantID',
    wechatPaymentCertificate:'payment certificate',
    clickUpload:'click upload',
    only500k:"only the certificate file can be uploaded,and it can't exceed 500kb",
    certificatePassword:'certificate password',
    paymentCollectionDetails:'payment collection details',
    paymentCollectionInformationOfThisAccountIsNotConfigured:'payment collection information of this account is not configured!',
    pleaseCompleteThePaymentCollectionConfiguration:'please complete the payment collection configuration!',
    currently1FileIsLimitedToBeSelected:'currently 1 file is limited to be selected,，this time',
    filesAreSelected:'files are selected',
    total:'total',
    others:'others',
    weChatMerchants:'WeChat merchants',
    allocationSucceeded:'allocation succeeded',
  },
  stc:{
    addTemplate:'add template',
    addEquipmentType:'add equipment type',
    templateName:'template name',
    remark:'remark',
    notConfigured:'not configuration',
    configureTemplate:'configure template',
    cupTypeParameterConfiguration:'cup type parameter configuration',
    channelParameterConfiguration:'channel parameter configuration',
    classification:'classification',
    androidWithRecipe:'Android (with recipe library)',
    androidWithoutRecipe:'Android (without recipe library)',
    selectPage:'select page',
    clickSelect:'click select',
    selectedPage:'selected page',
    selectTemplate:'select template',
    keySetting:'key setting',
    ingredientName:'ingredient name',
    fullAmountValue:'full amount value',
    powderDispensingRate:'powder dispensing rate',
    alarmValue:'alarm value',
    salesChannel:'sales channel',
    userLevel:'user level',
    user1Level:'user 1 level',
    user2Level:'user 2 level',
    user3Level:'user 3 level',
    user4Level:'user 4 level',
    user5Level:'user 5 level',
    user6Level:'user 6 level',
    user7Level:'user 7 level',
    user8Level:'user 8 level',
    selectLevel:'select level',
    selectedUserLevel:'selected user level',
    contactPhoneNumber:'phone number',
    mailbox:'mailbox',
    equipmentTypeName:'equipment type name',
    equipmentTypeNo:'equipment type NO',
    pleaseSelectACategory:'please select a category',
    pleaseEnterComments:'please enter comments',
    pleaseEnterEquipmentTypeNO:'please enter equipment type NO',
    pleaseEnterEquipmentTypeName:'please enter equipment type name',
    editEquipmentType:'edit equipment type',
    pleaseSelectTemplate:'please select template',
    newAddedParameter:'new added parameter',
    theKeyHasBeenDeleted:'the key has been deleted',
    modifyTheKeySetting:'modify the key setting',
    pleaseEnterTheValue:'please enter the value',
    pleaseEnterTheVariableName:'please enter the variable name',
    pleaseEnterMultiple:'please enter multiple',
    templateConfiguration:'template configuration',
    newAddedKeySetting:'new added key setting',
    step1:'step 1',
    step2:'step 2',
    nextStep:'next step',
    noIngredient:'no ingredient',
    newAddedConfiguration:'new added configuration',
    selectIngredient:'select ingredient',
    newAddedSalesChannel:'new added sales channel',
    editSalesChannel:'edit sales channel',
    salesChannelName:'sales channel name',
    salesChannelNO:'sales channel NO',
    autoGenerate:'auto generate',
    pleaseEnterUserName:'please enter user name',
    pleaseEnterContactPhoneNumber:'please enter contact phone number',
    pleaseEnterTheEmailAddress:'please enter the E-mail address',
    pleaseEnterATemplateName:'please enter a template name',
    pleaseEnterTheParameterName:'please enter the parameter name',
    selectAUser:'select a user',
    confirmToRemove:'confirm to remove',
    addNewTemplateSuccessfully:'add new template successfully',
    addNewTemplateUnsuccessfully:'add new template unsuccessfully',
    thisOperationWillPermanentlyDeleteTheTemplate:'this operation will permanently delete the template?',
    modifyTheEquipmentTypeSuccessfully:'modify the equipment type successfully!',
    pleaseCompleteTheChannelInformation:'please complete the channel information',
    deleteTheEquipmentTypeSuccessfully:'delete the equipment type successfully!',
    addNewKeySuccessfully:'add new key successfully!',
    newlyAddKeyConfigurationSuccessfully:'newly add key configuration successfully!',
    newlyAddParameterConfigurationSuccessfully:'newly add parameter configuration successfully!',
    pleaseNewlyAddAtLeastOneParameter:'please newly add least one parameter!',
    failedToGetChannelData:'failed to get channel data!',
    pleaseSelectAnIngredient:'please select an ingredient!',
    uploadSuccessfully:'upload successfully',
    newlyAddSalesChannelSuccessfully:'newly add sales channel successfully!',
    modifySalesChannelSuccessfully:'modify sales channel successfully!',
    deleteSalesChannelSuccessfully:'delete sales channel successfully!',
    thisOperationWillPermanentlyDeleteTheUser:'this operation will permanently delete the user.continue or not？',
    pleaseSelectLevel1User:'please select level 1 user',
    thereIsNoUserBoundToTheCurrentAccount:'there is no user bound to the current account!',
    newlyAddedUser:'newly added user',
    editUser:'edit user',
    commodityAmount:'commodity amount',
    refundSucceeded:'refund succeeded',
    theExportLimitIsLessThan1Million:'the export limit is less than 1 million,please query again!',
    editTemplate:'edit template',
    channelNo:'channel no',
    pleaseCompleteTheEquipmentTypeInformation:'please complete the equipment type information',
  },
  saledata:{
    transactionMode:'trading mode',
    paymentMethod:'payment',
    systemOrderNumber:'system order number',
    orderStatus:'order status',
    orderNO:'order NO',
    contactType:'contact type',
    nonContactType:'non contact type',
    free:'free',
    wechat:'WeChat',
    aliPay:'AliPay',
    commodityName:'commodity name',
    cupTypeName:'cup type name',
    paymentTime:'payment time',
    unPaid:'un paid',
    paid:'paid',
    commodityDeliverySucceeded:'commodity delivery succeeded,order completed',
    commodityDeliveryFailed:'commodity delivery failed,refund in progress',
    refunded:'refunded',
    refund:'refund',
    refundInProgress:'refund in progress',
    commodityRefund:'commodity refund',
    refundAmount:'refund amount',
    confirmRefund:'confirm refund',
    commodityDeliveryFailed2:'commodity delivery failed',
  },
  datamanagement:{
    equipmentNameOrNo:'equipment No/name',
    equipmentGroup:'equipment group',
    productNameOrNo:'product No/name',
    productNo:'product No',
    productName:'product name',
    allProductQty:'all product qty',
    allProductAmount:'all product amount',
    singleProductQty:'single product qty',
    singleProductAmount:'single product amount',
    totalAllProductQty:'total all product qty',
    totalAllProductAmount:'total all product amount',
    totalSingleProductQty:'total single product qty',
    totalSingleProductAmount:'total single product amount',
    exportSuccess:'export succeeded',
    exportFailed:'export failed, please retry after refresh',
  },
  remotecontrol:{
    upgradeAndroidProgram:'upgrade android program',
    upgradeMainBoardProgram:'upgrade mainBoard program',
    pleaseTickTheEquipmentFirst:'please tick the equipment first',
    whetherLocked:'whether locked',
    networkStatus:'network status',
    remoteRestart:'remote restart',
    lock:'lock',
    unlock:'unlock',
    onlyApk:'only apk files can be uploaded',
    historyUploadRecord:'history upload record',
    upgradeNow:'upgrade now',
    onlyBin:'only the bin/bin.TR file can be uploaded',
    pleaseSelectTheSameEquipmentType:'please select the same equipment type',
    normal:'normal',
    locking:'locking',
    online:'online',
    offline:'offline',
    selectFile:'select file',
    operationUser:'operation user',
    operationItem:'operation item',
    modifyContent:'modify content',
    operationIP:'operation IP',
    operationTime:'operation time',
    mainBoardSoftwareVersion:'main board software version',
    failedToQueryFileList:'failed to query file list!status code:',
    upgradeAndroidSuccessfully:'upgrade android successfully!',
    upgradeMainBoardSoftwareSuccessfully:'upgrade mainBoard software successfully!',
    theEquipmentDoesNotNeedToBeUnlocked:'the equipment does not need to be unlocked!',
    theEquipmentDoesNotNeedToBeLocked:'the equipment does not need to be locked!',
    pleaseWait:'please wait......',
    equipmentRestartSucceeded:'equipment restart succeeded',
    wash:'cleaning and stirring',
    eDoorLock:'e-door lock',
    takeDoorLock:'cup-taking door lock',
    resetCup:'reset and cup-dropping mechanism',
  },
  operatelog:{
    operationLog:'operation log',
    userLogin:'user login',
    signIn:'sign in',
    newEquipmentParameters:'new equipment parameters',
    deleteCup:'delete cup',
    recipeLibraryManagement:'recipe library management',
    deleteRawMaterials:'delete raw materials',
    uploadFiles:'upload files',
    file:'file',
    newRawMaterials:'new raw materials',
    updateDrinks:'update drinks',
    newCupSize:'new cup size',
    updateCupSize:'update cup size',
    newKeyConfiguration:'new key configuration',
    updateAndroidPrograms:'update android programs',
    updateTheMotherboardProgram:'update the motherboard program',
    equipmentOperation:'equipment operation',
    deleteDeviceParameters:'delete device parameters',
    newEquipment:'new equipment',
    bindingCupType:'binding cup type',
    updateDevice:'update device',
    deleteDevice:'delete device',
    bindingDevice:'binding device',
    newSalesChannel:'new sales channel',
    deleteFile:'delete file',
    newDrinks:'new drinks',
    newUser:'new user',
    deleteUser:'delete user',
    updateRawMaterialData:'update raw material data',
    clearUsersDevice:"clear user's device",
    deleteAccount:'delete account',
    newAccount:'new account',
    newPermission:'new permission',
    assignRecipeLibrary:'assign recipe library',
    updateKeyInformation:'update key information',
    updateEquipmentParameters:'update equipment parameters',
    newConfigurationTemplate:'new configuration template',
    updateUser:'update user',
    deleteKeyConfigurationTemplate:'delete key configuration template',
    updateAccount:'update account',
    unbindingDevice:'unbinding device',
    deleteKeyConfiguration:'delete key configuration',
    deleteTask:'delete task',
    newEquipmentType:'new equipment type',
    deleteDeviceType:'delete device type',
    deleteCupSize:'delete cup size',
    clearAUsersCollectionAccount:"clear a user's collection account",
    bindCollectionConfiguration:'bind collection configuration',
    updateCollectionConfiguration:'update collection configuration',
    newMenu:'new menu',
    updateDeviceType:'update device type',
    updateSalesChannel:'update sales channel',
    batchBindingCupType:'batch binding cup type',
    batchEquipmentBindingCupType:'batch equipment binding cup type',
    deleteSalesChannel:'delete sales channel',
    addCoupon:'add coupon',
    deleteCoupon:'delete coupon',
    modifyCoupon:'modify coupon',
    allocateEquipment:'allocate equipment',
    distributionChannel:'distribution channel',
    userManagement:'user management',
    loginAccount:'login account',
    permissionManagement:'permission management',
    recipeLibraryAssignment:'recipe library assignment',
    remoteControl: 'remote control',
    task:'task',
    standardDataConfiguration: 'standard data configuration',
    collectionConfiguration: 'collection configuration',
    system:'system',
    coupon:'coupon',
    equipmentManagement:'equipment management',
  },
  trafficwarning:{
    iotCardNo:'iot card no',
    activationTime:'activation time',
    usedFlow:'used flow',
    remainingFlow:'remaining flow',
    platformBelongedTo:'platform belonged to',
    newPlatform:'new platform',
    oldPlatform:'old platform',
    operator:'operator',
    refreshTime:'refresh time',
    read:'read',
    activateStartDate:'activate start date',
    activateEndDate:'activate end date',
    expirationTime:'expiration time',
    cardStatus:'card status',
    totalFlow:'total flow',
    pleaseEnterTheIOTCardNumber:'please enter the IOT card number',
    newlyAddIOTCardSuccessfully:'newly add IOT card successfully',
    pleaseCompleteCardNumberInformation:'please complete card number information',
    oneClickRead:"one click read",
  },
  myduty:{
    taskName:'task name',
    status:'status',
    failureReason:'failure reason',
    taskType:'task type',
    inProgress:'in progress',
    complete:'complete',
    failure:'failure',
    startTime:'start time',
    completionTime:'completion time',
    orderExport:'order export',
    equipmentFaultExport:'equipment fault export',
    batchEquipmentAllocationFormula:'batch equipment allocation formula',
    batchEquipment:'batchEditEquipment',
    unSuccessfulEntries:'unsuccessful entries',
  },
  home:{
    setting:'setting',
    logOut:'log out',
    homePage:'home page',
    equipmentManagement:'equipment management',
    equipmentList:'equipment list',
    equipmentQualityInspection:'equipment quality inspection',
    assignEquipment:'assign equipment',
    faultList:'fault list',
    accountManagement:'account management',
    loginAccount:'login account',
    paymentConfiguration:'payment configuration',
    beverageManagement:'beverage management',
    nbbg2RecipeLibrary:'NBBG2 recipe library',
    newCombiRecipeLibrary:'E2S recipe library',
    recipeLibraryAssignment:'recipe library assignment',
    standardDataConfiguration:'standard data configuration',
    equipmentTypeConfiguration:'equipment type configuration',
    salesChannelConfiguration:'sales channel configuration',
    userLevelConfiguration:'user level configuration',
    salesDataStatistics:'sales data statistics',
    dataManagement:'data management',
    locationSalesStatistics:'location sales statistics',
    productSalesStatistics:'product sales statistics',
    remoteControl:'remote control',
    flowEarlyWarning:'flow early warning',
    myTask:'my task',
    assistMaintenance:'Assist O&M',
    advertiseManagement:'Advertise Management',
    maintenanceRecord:'Maintenance Record',
    orderManagement:'Order Management',
    userLogin:'user login',
    cloudPlatform:'cloud platform',
    forgotPassword:'forgot password',
    rememberMe:'remember me',
    login:'login',
    loginSuccessfully:'login successfully',
    teaCupManagement:'tea Cup Management',
    cupteamachinemanagement:'cup tea machine management',
    formulaclass3S:'formula class 3S',
    formulamanage:'formula manage',
    applet:'applet',
    appletmember:'applet member',
    coupon:'coupon',
    Rechargestr:'recharge strategy',
    Newbenefits:'newcomer benefits',
    Sginbenefits:'sign in benefits',
    washrecords:'wash records',
    calibrationRecords:'calibration records'
  },
  homepage:{
    salesData:'sales data',
    salesTotalAmount:'sales total amount',
    salesTotalNumberOfCups:'sales total cups',
    ranking:'ranking',
    salesNumberOfCups:'cup',
    todaySalesData:'today sales data',
    todaySalesAmount:'today sales amount',
    todaySalesNumberOfCups:'today sales number of cups',
    cup:'cup',
    equipmentSalesChampion:'equipment sales champion',
    beverageSalesChampion:'beverage sales champion',
    equipmentNormal:'normal',
    equipmentOffline:'offline',
    equipmentNotActive:'not active',
    fault:'fault',
    beverageRanking:'beverage ranking',
    alarmStatistics:'alarm statistics',
    bigDataBulletinBoard:'big data bulletin board',
    welcome:'welcome',
    dataLoading:'data loading',
    operationAndMaintenanceFailure:'operation and maintenance failure',
    controlSystemFailure:'control system failure',
    waterCircuitUnitFailure:'water circuit unit failure',
    heatingCoolingFailure:'heating/cooling failure',
    feedingUnitFailure:'feeding unit failure',
    others:'others',
    huifuappconfiguration:'Huifu application configuration',
    huifuuserconfiguration:'Huifu User Configuration',
    huifupayconfiguration:'Huifu Payment Configuration',
    todaybeverage:'today beverage',
    equipdailydata:'equip dailydata',
    equiptotaldata:'equip totaldata',
    salestoday:'sales today',
    amounttoday:'amount today',
    Currentlymalfunction:'Currently malfunction',
    Currentlymalfunctionnow:'Currently malfunction now',
    totalsales:'total sales',
    equipmentNo:'  equip No',
    openfullscreen:'open fullscreen',
    closefullscreen:'close fullscreen',
  },
  surong:{
    beverageName:'beverage name',
    pleaseSelectAGroup:"please select a group",
    cupSizeEditing:'cup size editing',
    category:'category',
    coffee:'coffee',
    milkTea:'milkTea',
    soybeanMilk:'soybeanMilk',
    juice:'juice',
    ingredientName:'ingredient name',
    alarmExtensionValue:'alarm extension value',
    cupType:'cup type',
    nameDisplayedOnTheScreen:'name',
    beverageType:'beverage type',
    englishNameidisplayedOnTheScreen:'english name',
    ingredientsSelection:'ingredients selection',
    clickSelect:'click select',
    cupTypeTemplate:'cup type template',
    recipeGrouping:'recipe grouping',
    cupTypeParameter:'cup type parameter',
    whetherUniversal:'whether universal',
    clickToSelectTheUser:'click to select the user',
    total:'total',
    pleaseEnterTheCupSizeName:'please enter the cup size name',
    beverageEnglishName:'beverage english name',
    recipeInformation:'recipe information',
    basicInformation:'basic information',
    pleaseEnterBeverageName:'please enter beverage name',
    pleaseEnterBeverageEnglishName:'please enter beverage english name',
    solublePowder1Select:'soluble powder 1 select',
    solublePowder2Select:'soluble powder 2 select',
    cupTypeInformation:'cup type information',
    newAddedCupType:'add cup type',
    selectAUser:'select a user',
    pleaseEnterTheAlarmExtensionValue:'please enter the alarm extension value',
    cupSizeName:'cup size name',
    cupSizeEnglishName:'cup size english name',
    pleaseSelectTheTypeOfDrink:'please select the type of drink',
    pleaseEnterTheNameOfTheRawMaterial:'please enter the name of the raw material',
    rawMaterialPicture:'raw material picture',
    classification:'classification',
    pleaseEnterTheCupNumber:'please enter the cup number',
    coffeeBeanSelection:'coffee bean selection',
    liquidMilkSelection:'liquid milk selection',
    pleaseSelectCupType:'please select cup type',
    typeOfDrink:'type of drink',
    selectRecipeLibrary:'select recipe library',
    grouping:'grouping',
    selectedRecipes:'selected recipes',
    standardsForInstantDissolvers:'standards for instant dissolvers',
    areYouSureToDeleteThisCupSize:'are you sure to delete this cup size',
    succeededInModifyingTheCupSize:'succeeded in modifying the cup size',
    nameCannotBeEmpty:'name cannot be empty',
    pleaseEnterTheCupName:'please enter the cup name',
    succeededInAddingCupType:'succeeded in adding cup type',
    theDrinkInformationDoesNotExistPleaseRefreshAndTryAgain:'the drink information does not exist,please refresh and try again',
    pleaseCompleteTheDrinkInformation:'please complete the drink information',
    pleaseCompleteTheCupTypeInformation:'please complete the cup type information',
    hotDrink:'hot drink',
    coldDrink:'cold drink',
    pleaseSelectAType:'please select a type',
    onSiteMillStandard:'on site mill standard',
    pleaseSelectCoffeeBeans:'please select coffee beans',
    pleaseSelectInstantPowder:'please select instant powder',
    pleaseSelectFreshMilk:'please select fresh milk',
    listOfDrinkCups:'list of drink cups',
    coffeeBean:'coffee bean',
    instantPowder:'instant powder',
    liquidMilk:'liquid milk',
    hot:'hot',
    cold:'cold',
  },
  washrecords: {
    washproject: 'wash project',
    executiontime: 'execution time',
    calibrationvalue: 'calibration value',
  },
  promotions:{
      addpromotions: 'add promotions',
      expiredate: 'expire date：',
      calibrationvalue: 'calibration value',
      promotionsname: 'promotions name',
      deductionprice: 'deduction price',
      couponsnumber: 'coupons number',
      couponsnumberextra: 'coupons num extra',
      productcategory: 'product category',
      promotionsnameadd: 'promotions name add*：',
      deductionpriceadd: 'deduction price add*：',
      couponsnumberadd: 'coupons number add*：',
      selecttime:'select time',
      distributecoupons:'distribute coupons',
      phonenumber:'phone number',
      distributenumber: 'distribute number',
      distribute:'distribute'
  },
    NewEmployeeBenefits:{
        isnewcomercoupon: 'Is newcomers receive coupons',
        isnewcomerpoints: 'Is newcomers receive points',
        isnewcomerbalance: 'Is new employee distribute balance',
        isoldcomercoupon: 'Is elderly distribute coupons',
        isoldcomerpoints: 'Is elderly receive points',
        isoldcomerbalance: 'Is elderly distribute balance',
        newcomercouponnumber:'newcomer coupon number',
        newcomercoupons:'newcomer coupons',
        newcomerpoints:'newcomer points',
        newbalancequantity:'newcomer balance quantity',
        oldcomercouponnumber:'oldcomer coupon number',
        oldcomerpoints:'oldcomer points',
        oldbalancequantity:'oldcomer balance quantity',
        createnow:'create now',
    },
    SignInBenefits:{
        signinrule:'Sign in rule configuration',
        signinpointsday:'Daily check-in points',
        signinbalanceday:'Daily check-in balance',
        signincouponsday:'Daily check-in coupon',
        signincouponsnumberday:'Number of daily check-in coupons',
        addedrewardsdays:'Number of days for triggering value-added rewards',
        addedrewardsdayssigninpoints:'Daily check-in points after value-added',
        addedrewardsdayssigninbalance:'Daily check-in balance after value-added',
        addedrewardsdayssignincoupons:'Daily check-in coupon after value-added',
        addedrewardsdayssignincouponsnumber:'Number of daily check-in coupons after appreciation',
        accumulatedsigninreward:'Accumulated check-in reward configuration',
        daysnumber:'days number',
        points:'points',
        balance:'balance',
        coupons:'coupons',
        couponsnumber:'coupons number',
        continuoussigninreward:'Continuous check-in reward configuration',
    },
  HuiFuAppConfig:{
    appid:'appid',
    appconfiguration:'app configuration',
    createtime:'create time'
  },
  HuiFuMenberConfig:{
    address:"address",
    addperson:'add person',
    addEnterprise:'add Enterprise',
    userID:'userID',
    payaccountId:'payaccount Id',
    payaccountoperation:'payaccount operation',
    binding:'binding',
    unbind:'unbind',
    HuiFuuser:'HuiFu user',
    Address:'Address',
    gender:'gender',
    Provincecode:'Province code',
    RegionCode:'Region Code',
    socialCreditCode:'socialCredit Code',
    socialCreditCodeExpires:'socialCredit Code Expires',
    legalPerson:'legal Person',
    legalCertId:'legal CertId',
    legalCertIdExpires:'legal CertId Expires',
    legalMP:'legal phone number',
    businessScope:'business Scope',
    settleaccountconfig:'settleaccount config',
    bankaccounttype:'bankaccount type',
    forpublic:'for public',
    forPrivate:'for Private',
    bankcardid:'bankcard id',
    bankcardname:'bankcard name',
    telNumber:'tel Number',
    certId:'cert Id',
    certtype:'cert type',
    identitycard:'identity card',
    bankcodepublic:'bankcode (public)',
    provcodepublic:'provcode (public)',
    areacodepublic:'areacode (public)',
  },
  HuiFuPaymentConfig:{
    belongingusers:'belonging users',
    configoperations:'config operations',
    bindapp:'bind app',
    bindledger:'bind ledger',
    bindsettlement:'bind settlement',
    settlementuser:'settlement user',
    proportion:'proportion',
    bindappid:'bind appid',
    EquipId:'EquipId',
  },
  rechargeStrategy:{
    couponstrategy:'coupon strategy',
    deductionamount:'deduction amount',
    rechargename:'recharge name',
    paidamountyuan:'paid amount',
    discountamountyuan:'discount amount',
    couponsnumber:'coupons number',
  },
  miniuser:{
    Authorizedpn:'Authorized phonenumber',
    profilepicture:'profile picture',
    focustime:'focus time',
    availablecoupons:'available coupons',
    remainingcoupons:'remaining coupons',
    coupontype:'coupon type',
    issuedate:'issue date',
  },
  cupteamachinemanagement:{
    serial:'serial',
    MaterialAddSuccess:'Material Add Success',
    ConfirmEditSerioName:'Confirm Edit SerioName',
    MaterialStoreAssign: 'Material Store Assign',
    MaterialAssign: 'Material Assign',
    MilkTeaCopy: 'Copy Milk Tea',
    expMilkList: 'expand MilkList',
    MilkList: 'MilkList',
    checkStoreAssigned: 'check Assigned Store',
    checkMaterialAssigned: 'check Assigned Material',
    InputMilkSort:'Input MilkSort',
    InputMilkSerioSort:'Input MilkSerio Sort',
    KeySortMilk:'KeySort Milk',
    EditSuccess:'Edit Success',
    ConfirmDistribute:'Confirm Distribute',
    parameterconfig:'parameter config',
    storageconfig:'storage config',
    copyoneparameter:'copy one parameter',
    copyfunctionparameter:'copy function parameter',
    copykeyparameter:'copy keyparameter',
    copyparameter:'copy parameter',
    milkname:'milk name',
    milkprice:'milk price',
    milksort:'milk sort',
    ishotenabled:'is hot enabled',
    iscoldenabled:'is cold enabled',
    editdrink:'edit drink',
    Selection:'Selection',
    teadistribution:'tea distribution',
    keyconfigsscreen1:'keyconfigs screen 1',
    keyconfigsscreen2:'keyconfigs screen 2',
    keyconfigsscreen3:'keyconfigs screen 3',
    seroBindQuantity:'sero Bind Quantity',
    Expandseries:'Expand series',
    Confirmdistributetea:'Confirm distribute tea',
    allocatedteadistribute:'allocated tea distribute',
    milkteaid:'milktea id',
    milkteaname:'milktea name',
    serioSort:'serio Sort',
    bindedquantity:'binded quantity',
    Isenabled:'Is enabled',
    AssignDrink:'Assign Drink',
    expseriolist:'expand seriolist',
    editserio:'edit serio',
    milkteadetails:'milktea details',
    hotname:'hot tea name',
    coldname:'cold tea name',
    hotparameter:'hot tea parameter',
    coldparameter:'cold tea parameter',
    hotstorageno:'hot tea storageNo',
    coldstorageno:'cold tea storageNo',
    serialstate:'serial state',
    disable:'disable',
    enable:'enable',
    recoveryamount:'recovery amount',
    warningamount:'warning amount',
    cover:'cover',
    copynewcup:'copy new cup',
    assignnewcup:'assign new cup',
    screen:'screen',
    copycup:'copy cup',
  },
  materialconfig: {
    EquipId:"EquipId",
    Materialid:"Materialid",
    pleaseCompleteTheMaterialInformation: 'please Complete The Material Information',
    AddMaterialSuccess: 'Add Material Success',
    MaterialUpdateSuccess: 'Update Material Success',
    MaterialEditTitle: 'Edit Material',
    MilkCupMaterialInfoCode: 'MilkCup Material Info Code',
    MilkCupMaterialInfoName: 'MilkCup Material Info Name',
    MilkCupMaterialInfoMargin: 'MilkCup Material Info Margin',
    MilkCupMaterialInfoType: 'MilkCup Material Info Type',
    AddMaterialInfo: 'Add Material Info',
    materialstate: 'material state',
    materialcreatetime: 'material create time',
  },
  materialstorage: {
    materialstorageid: 'material storage id',
    DeleteSuccess:'Delete Success',
    AddSuccess:'Add Success',
    pleaseCompleteTheMaterialInformation:'please Complete The Material Information',
    pleaseCompleteTheStorageInformation:'please Complete The Storage Information',
    BindSuceess:'Status modification successful',
    assignmaterial: 'assign material',
    ClearInput:'Clear Input',
    MaterialStoreAddTitle: 'Add Material Store',
    inputmaterialstoragecode: 'input material storage code',
    inputmaterialstoragename: 'input material storage name',
    materialstoragecode: 'material storage code',
    DTUNumber: 'equip no',
    materialstoragename: 'material storage name',
    inputmaterialcode: 'input material code',
    materialid: 'material id',
    inputmaterialname: 'input material name',
    materialstate: 'material state',
    materialcreatetime: 'material create time',
  },
  specconfig: {
    groupid: 'group id',
    materialcode: 'material code',
    inputmaterialcode: 'input material code',
    materialname: 'material name',
    inputmaterialname: 'input material name',
    materialstate: 'material state',
    materialcreatetime: 'material create time',
    MilkCupMaterialInfoType: 'MilkCup Material Info Type',
  },
  formulamanagement: {
    createnewcuptea: 'create new drinks',
    SerioId:'series Id',
    equipSetSerio:'Expand equip serieslist',
    SerioSelectEquip: 'Please select equip for series',
    MilkCupID:'MilkCup ID',
    pleaseCompleteTheFormulaInformation:'please Complete Formula Information',
    UpdateSuccess:'Update Success',
    DeleteSuccess:'Delete Success',
    AddSuccess:'Add Success',
    formulaEditTitle:'Edit formula series',
    formulaEdit: 'Edit formula',
    formulaDelete: 'Delete formula',
    cupserioname: 'cup series name',
    cuptype:'cup type' ,
    createnewcup: 'create new cup',
    serioname: 'series name',
    inputformulamanacode: 'input formula code',
    inputserioname: 'input serio name',
    inputcupserio: 'input cup series state',
    formulacreatetime: 'formula create time',
  },
  formulaclass: {
    bindstorage:'Bind silo No',
    teatoseries:'Tea allocation to series',
    TeaVol:'TeaVol',
    PressGear:'PressGear',
    PressTime:'PressTime',
    PressTemp:'PressTemp',
    WaterVol:'WaterVol',
    SoakTime:'SoakTime',
    MilkPrice:'MilkPrice',
    inputformulaPrice:'input formula Price',
    batchassignment:'batch assignment',
    createnewMilkcup:'create new Milkcup',
    inputMaterialStore:'input Material Store',
    MaterialStorevalue:'Material Store value',
    BrewTeaTime:'BrewTeaTime',
    remake:'remake',
    SoakTeaTime:'SoakTeaTime',
    IceWaterTime:'IceWaterTime',
    HotWaterTime:'HotWaterTime',
    PowderWeight:'PowderWeight',
    PowderDelayTime:'PowderDelayTime',
    PowderTrueTime:'PowderTrueTime',
    PowderFalseTime:'PowderFalseTime',
    StirringRate:'StirringRate',
    ExtraStirringTime:'ExtraStirringTime',
    IceExWaterTime:'IceExWaterTime',
    IceExWaterDeTime:'IceExWaterDeTime',
    HotExWaterTime:'HotExWaterTime',
    HotExWaterDeTime:'HotExWaterDeTime',
    ActrualPowder:'ActrualPowder',
    inputcupmilkID:'input cupmilk ID',
    cupmilkID:'cupmilk ID',
    MilkCupEditTitle:'Edit MilkCup',
    checkMilkCupAssigned:'check Assigned MilkCup',
    CopySuccess: 'Copy Success',
    inputserioname: 'input series name',
    MilkCupCopyTitle:'Copy MilkCup',
    MilkCupCopy:'MilkCup Copy',
    DeleteSuccess:'Delete Success',
    AddSuccess: 'Add Success',
    pleaseinputmaterial: 'please input material',
    inputdtuformula: 'input equipNo',
    SelectMilkCup: 'Select MilkCup',
    SelectMaterialStore: 'Select Material Store',
    materialstore: 'material store',
    inputmaterialstore: 'input material store',
    formulatype: 'formula type',
    formulabigcup: 'formula big cup',
    HotDrink: 'HotDrink',
    ColdDrink: 'ColdDrink',
    inputformulacoldcup:'input formula cold cup',
    inputformulahotcup:'input formula hot cup',
    formulacode: 'formula code',
    formulaname: 'formula name',
    formulastate: 'formula state',
    formulacreatetime: 'formula create time',
    inputformulaname: 'input formula name',
    inputHotDrinkParm: 'input HotDrink Parameter',
    inputColdDrinkParm: 'input ColdDrink Parameter',
    pleaseinputmaterialnumber: 'please input material number',
    HotMilkTemp: 'HotMilk Temp',
    ColdMilkTemp: 'ColdMilk Temp',
    MilkTempNumber: 'Milk Temp Number',
    inputMilkHotTempNumber: 'input Milk Hot TempNumber',
    inputMilkColdTempNumber: 'input Milk Cold TempNumber',
  },
  ordermanagement:{
    orderManagement:'Order Management',
    orderNo:'Order No.',
    goodName:'Product Name',
    title:'Title',
    outTradeNo:'Out Trade No.',
    payMode:'Payment Method',
    orderStatus:'Order Status',
    orderForm:'Order Method',
    totalAmount:'Total Amount',
    actualAmount:'Actual Amount',
    settingAmount:'Setting Amount',
    cupAmountFineAdjustment:'Cup Fine Adj.(%)',
    produceState:'Production State',
    equipmentName:'Equipment Name',
    startTime:'Start Time',
    endTime:'End Time',
    addOrder:'Add Order',
    editOrder:'Edit Order',
    remark:'Remark',
    reset:'Reset',
    cupTypeID:'Cup Type ID',
    keyConfigID:'Key Config ID',
    keySort:'Key Sort',
    beverageID:'Beverage ID',
    appAccountID:'App Account ID',
    equipmentGroupID:'Equipment Group ID',
    country:'Country',
    province:'Province',
    city:'City',
    district:'District',
    orderTime:'Order Time',
    pleaseEnterOrderNo:'Please enter order number',
    pleaseEnterGoodName:'Please enter product name',
    amountMinError:'Amount cannot be negative',
    dtuNo:'DTU No.',
    selectDtu:'Select DTU',
    tabBasic:'Basic Info',
    tabAmount:'Amount',
    tabEquipment:'Equipment',
    tabLocation:'Location',
    addSuccess:'Order added successfully',
    editSuccess:'Order updated successfully',
    confirmDelete:'Confirm to delete this order?',
  },
}



// WEBPACK FOOTER //
// ./src/components/language/en.js